import { DateTime } from '@ksyos/date-time';
import type { IProcessActivityWithChecked } from '@frontend/components/interfaces';

export function isUsedForReprocessing(item: IProcessActivityWithChecked, payments: IProcessActivityWithChecked[]) {
    if (item.payoutRecord.id === null) {
        return true;
    }

    const activityPayouts = [
        ...payments.filter((activity) => activity.id === item.id && activity.payoutRecord.created_at !== null),
    ];
    if (activityPayouts.length === 1) {
        return true;
    }

    activityPayouts.sort((a, b) => {
        if (a.payoutRecord.created_at !== null && b.payoutRecord.created_at !== null) {
            return DateTime.from(a.dateSent).diff(b.dateSent);
        }

        return 0;
    });

    return activityPayouts[0].payoutRecord.id === item.payoutRecord.id;
}

export function isProcessingLabelVisible(
    item: IProcessActivityWithChecked,
    payments: IProcessActivityWithChecked[],
    reprocessedActivities: string[]
) {
    return isUsedForReprocessing(item, payments) && reprocessedActivities.indexOf(item.id) !== -1;
}
